import { render } from "./AccountStat.vue?vue&type=template&id=1754f4cb&scoped=true"
import script from "./AccountStat.vue?vue&type=script&lang=js"
export * from "./AccountStat.vue?vue&type=script&lang=js"

import "./AccountStat.vue?vue&type=style&index=0&id=1754f4cb&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1754f4cb"]])

export default __exports__